import _defineProperty from "/tmp/builds/de68db43-a648-439b-af7b-ea4f6d7841ed-develop-nodeV18-18/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { TAG_NAMES as $, NS, hasUnescapedText } from '../common/html.js';
import { escapeText, escapeAttribute } from 'entities/lib/escape.js';
import { defaultTreeAdapter } from '../tree-adapters/default.js'; // Sets

var VOID_ELEMENTS = new Set([$.AREA, $.BASE, $.BASEFONT, $.BGSOUND, $.BR, $.COL, $.EMBED, $.FRAME, $.HR, $.IMG, $.INPUT, $.KEYGEN, $.LINK, $.META, $.PARAM, $.SOURCE, $.TRACK, $.WBR]);

function isVoidElement(node, options) {
  return options.treeAdapter.isElementNode(node) && options.treeAdapter.getNamespaceURI(node) === NS.HTML && VOID_ELEMENTS.has(options.treeAdapter.getTagName(node));
}

var defaultOpts = {
  treeAdapter: defaultTreeAdapter,
  scriptingEnabled: true
};
/**
 * Serializes an AST node to an HTML string.
 *
 * @example
 *
 * ```js
 * const parse5 = require('parse5');
 *
 * const document = parse5.parse('<!DOCTYPE html><html><head></head><body>Hi there!</body></html>');
 *
 * // Serializes a document.
 * const html = parse5.serialize(document);
 *
 * // Serializes the <html> element content.
 * const str = parse5.serialize(document.childNodes[1]);
 *
 * console.log(str); //> '<head></head><body>Hi there!</body>'
 * ```
 *
 * @param node Node to serialize.
 * @param options Serialization options.
 */

export function serialize(node, options) {
  var opts = _objectSpread(_objectSpread({}, defaultOpts), options);

  if (isVoidElement(node, opts)) {
    return '';
  }

  return serializeChildNodes(node, opts);
}
/**
 * Serializes an AST element node to an HTML string, including the element node.
 *
 * @example
 *
 * ```js
 * const parse5 = require('parse5');
 *
 * const document = parse5.parseFragment('<div>Hello, <b>world</b>!</div>');
 *
 * // Serializes the <div> element.
 * const html = parse5.serializeOuter(document.childNodes[0]);
 *
 * console.log(str); //> '<div>Hello, <b>world</b>!</div>'
 * ```
 *
 * @param node Node to serialize.
 * @param options Serialization options.
 */

export function serializeOuter(node, options) {
  var opts = _objectSpread(_objectSpread({}, defaultOpts), options);

  return serializeNode(node, opts);
}

function serializeChildNodes(parentNode, options) {
  var html = ''; // Get container of the child nodes

  var container = options.treeAdapter.isElementNode(parentNode) && options.treeAdapter.getTagName(parentNode) === $.TEMPLATE && options.treeAdapter.getNamespaceURI(parentNode) === NS.HTML ? options.treeAdapter.getTemplateContent(parentNode) : parentNode;
  var childNodes = options.treeAdapter.getChildNodes(container);

  if (childNodes) {
    var _iterator = _createForOfIteratorHelper(childNodes),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var currentNode = _step.value;
        html += serializeNode(currentNode, options);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return html;
}

function serializeNode(node, options) {
  if (options.treeAdapter.isElementNode(node)) {
    return serializeElement(node, options);
  }

  if (options.treeAdapter.isTextNode(node)) {
    return serializeTextNode(node, options);
  }

  if (options.treeAdapter.isCommentNode(node)) {
    return serializeCommentNode(node, options);
  }

  if (options.treeAdapter.isDocumentTypeNode(node)) {
    return serializeDocumentTypeNode(node, options);
  } // Return an empty string for unknown nodes


  return '';
}

function serializeElement(node, options) {
  var tn = options.treeAdapter.getTagName(node);
  return "<".concat(tn).concat(serializeAttributes(node, options), ">").concat(isVoidElement(node, options) ? '' : "".concat(serializeChildNodes(node, options), "</").concat(tn, ">"));
}

function serializeAttributes(node, _ref) {
  var treeAdapter = _ref.treeAdapter;
  var html = '';

  var _iterator2 = _createForOfIteratorHelper(treeAdapter.getAttrList(node)),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var attr = _step2.value;
      html += ' ';

      if (!attr.namespace) {
        html += attr.name;
      } else switch (attr.namespace) {
        case NS.XML:
          {
            html += "xml:".concat(attr.name);
            break;
          }

        case NS.XMLNS:
          {
            if (attr.name !== 'xmlns') {
              html += 'xmlns:';
            }

            html += attr.name;
            break;
          }

        case NS.XLINK:
          {
            html += "xlink:".concat(attr.name);
            break;
          }

        default:
          {
            html += "".concat(attr.prefix, ":").concat(attr.name);
          }
      }

      html += "=\"".concat(escapeAttribute(attr.value), "\"");
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return html;
}

function serializeTextNode(node, options) {
  var treeAdapter = options.treeAdapter;
  var content = treeAdapter.getTextNodeContent(node);
  var parent = treeAdapter.getParentNode(node);
  var parentTn = parent && treeAdapter.isElementNode(parent) && treeAdapter.getTagName(parent);
  return parentTn && treeAdapter.getNamespaceURI(parent) === NS.HTML && hasUnescapedText(parentTn, options.scriptingEnabled) ? content : escapeText(content);
}

function serializeCommentNode(node, _ref2) {
  var treeAdapter = _ref2.treeAdapter;
  return "<!--".concat(treeAdapter.getCommentNodeContent(node), "-->");
}

function serializeDocumentTypeNode(node, _ref3) {
  var treeAdapter = _ref3.treeAdapter;
  return "<!DOCTYPE ".concat(treeAdapter.getDocumentTypeNodeName(node), ">");
}